import { render } from "./ClientSelect.vue?vue&type=template&id=4bd42059&scoped=true"
import script from "./ClientSelect.vue?vue&type=script&lang=js"
export * from "./ClientSelect.vue?vue&type=script&lang=js"

import "./ClientSelect.vue?vue&type=style&index=0&id=4bd42059&lang=scss&scoped=true"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd42059"]])

export default __exports__